import { render } from "./appointments-filter.vue?vue&type=template&id=2a72d565"
import script from "./appointments-filter.vue?vue&type=script&lang=js"
export * from "./appointments-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__